import React from 'react';
import styled from 'styled-components';
import { FaSave, FaTimes } from 'react-icons/fa';

import { Modal } from 'components/Modal';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

type UpdateStockConfirmationModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: (shouldUpdateStocks: boolean) => void;
    isLoading: boolean;
};

export const UpdateStockConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    isLoading,
}: UpdateStockConfirmationModalProps) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Mise à jour des quantités" closeOnBackgroundClick={!isLoading}>
            <ModalContent>
                <ModalText>Comment souhaitez-vous mettre à jour les quantités des produits?</ModalText>
                <DescriptionText>
                    - <strong>Avec mise à jour des stocks</strong>: Les quantités modifiées affecteront les stocks du
                    site entrepôt.
                    <br />- <strong>Sans mise à jour des stocks</strong>: Les quantités seront modifiées uniquement dans
                    ce bundle sans affecter les stocks.
                </DescriptionText>

                <ButtonsContainer>
                    <ButtonWrapper>
                        <TotemPrimaryButton disabled={isLoading} onClick={() => onConfirm(true)} $minWidth="200px">
                            <FaSave size={13} />
                            <ButtonLabel>Avec mise à jour des stocks</ButtonLabel>
                        </TotemPrimaryButton>
                    </ButtonWrapper>
                    <ButtonWrapper>
                        <TotemPrimaryButton
                            disabled={isLoading}
                            onClick={() => onConfirm(false)}
                            $minWidth="200px"
                            $isSecondaryStyle
                        >
                            <FaTimes size={13} />
                            <ButtonLabel>Sans mise à jour des stocks</ButtonLabel>
                        </TotemPrimaryButton>
                    </ButtonWrapper>
                </ButtonsContainer>
            </ModalContent>
        </Modal>
    );
};

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
`;

const ModalText = styled.p`
    font-size: 16px;
    margin-bottom: 15px;
    font-weight: 500;
    padding: 0 20px;
`;

const DescriptionText = styled.p`
    margin-bottom: 25px;
    line-height: 1.5;
    padding: 0 20px;
`;

const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;
`;

const ButtonWrapper = styled.div`
    margin-bottom: 15px;
    width: 100%;
    display: flex;
    justify-content: center;
`;

const ButtonLabel = styled.span`
    margin-left: 10px;
`;
